import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { getLinkForRepo } from '../../utils/getLinkForRepo'
import Icon from '../misc/Icons'
import { formatRepoGradesToString } from '../../utils/formatRepoGradesToString'
import { formatSubjectToString } from '../../utils/formatSubjectToString'
import RepoImage from '../discover/DiscoverRepoImage'

class AuthorPageRepoLink extends Component {
  render() {
    const { repo } = this.props
    let subject = ''
    if (repo.subject) {
      subject = formatSubjectToString(repo.subject)
    }
    let gradeString = ''
    if (repo.grade) {
      gradeString = formatRepoGradesToString(repo.grade)
    }

    let repoMetadata = null
    if (repo.subject && repo.grade) {
      repoMetadata = `${subject} · ${gradeString}`
    }
    if (repo.subject && !repo.grade) {
      repoMetadata = `${subject}`
    }
    if (!repo.subject && repo.grade) {
      repoMetadata = `${gradeString}`
    }

    return (
      <Link to={getLinkForRepo(repo)}>
        <div className='authorPageRepoLink'>
          <div className='authorPageRepoLink-repoImageContainer'>
            <RepoImage repo={repo} autoFormatAndQuality className='pageHeaderTop-leftBadge-repoImage' />
          </div>
          <div className='authorPageRepoLink-title'>
            {repo.name}
          </div>

          {repoMetadata && (
          <div className='authorPageRepoLink-metadata'>
            {repoMetadata}
          </div>
          )}

          {repo.description && (
          <div className='authorPageRepoLink-description'>
            {repo.description}
          </div>
          )}

          <div className='authorPageRepoLink-rightArrow'>
            <Icon name='chevron-right' />
          </div>

        </div>
      </Link>
    )
  }
}

export default AuthorPageRepoLink
